export const SCORE_KEY = 'scores_key';

export const UNNAMED_SCORE = 'Anonymous';

export const Pages = {
  Game: '/game',
  HighScores: '/scores',
  Home: '/',
}

export const Key = {
  Enter: 13,
}



// WEBPACK FOOTER //
// ./src/dots/DotsGame/utils/constants.ts